import { useMatch, useRouteLoaderData } from "react-router-dom";
import { getWizardSteps } from "@app/utils/inspection";
import Config from "@app/constants/Config";

export const useWizardSteps = () => {
	const { inspectionConfig } = useRouteLoaderData("inspection");
	const followupMatch = useMatch(`${Config.BASE_PATH}/inspection/new-follow-up/:inspectionId`);
	const { step } = useMatch(`${Config.BASE_PATH}/inspection/:inspectionId/:step`)?.params || {};

	// prepare steps
	if (followupMatch) {
		return getWizardSteps("new-follow-up", inspectionConfig);
	}
	return getWizardSteps(step, inspectionConfig);
};
